import { motion } from "framer-motion";
import { Search, PenLine, Hammer, Rocket, Sparkles } from "lucide-react";
import { Chapter, Reveal } from "@/components/Chapter";
import { useContent } from "@/content";

const ICONS = { Search, PenLine, Hammer, Rocket };

export const Process = () => {
  const { PROCESS } = useContent();
  return (
  <section id="process" className="relative bg-white border-y border-slate-200 py-24 md:py-32 overflow-hidden" data-testid="process-section">
    <div className="glow-blue-light absolute -bottom-40 -left-40 h-[480px] w-[480px] rounded-full pointer-events-none" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-8">
      <Chapter
        id="02"
        name="How we work"
        title="A clear process, written down before we start."
        sub="Four steps, every project. You always know what happens next, who is doing it, and when it lands."
      />

      <div className="relative grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        <motion.span
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          className="hidden lg:block absolute top-[38px] left-[12%] right-[12%] h-px origin-left bg-gradient-to-r from-amber-400 via-blue-500 to-amber-400"
        />
        {PROCESS.map((p, i) => {
          const Icon = ICONS[p.icon] || Sparkles;
          return (
            <Reveal key={p.step} delay={i * 0.12} className="h-full">
              <motion.div
                whileHover={{ y: -8 }}
                transition={{ type: "spring", stiffness: 260, damping: 20 }}
                className="group relative h-full rounded-2xl border border-slate-200 bg-slate-50/60 p-7 hover:bg-white hover:border-amber-400/60 hover:shadow-xl hover:shadow-slate-900/5 transition-colors duration-500"
                data-testid={`process-step-${i}`}
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="relative z-10 inline-flex h-[76px] w-[76px] items-center justify-center rounded-2xl bg-white border border-slate-200 shadow-sm transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-105">
                    <Icon className="h-7 w-7 text-amber-500" />
                  </span>
                  <span className="font-mono text-3xl font-bold text-slate-200 group-hover:text-amber-400/60 transition-colors duration-500">{p.step}</span>
                </div>
                <h3 className="text-lg sm:text-xl font-semibold text-[#0B1528] mb-2.5">{p.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{p.desc}</p>
              </motion.div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
};
